import { Control, Controller } from "react-hook-form";
import CustomAutoComplete from "@/modules/common/components/input/dropdowns/auto-complete";
import {
  FetchDropDownConfig,
  FormSection,
  StaticDropDownConfig,
} from "@/modules/property-tracks/types";
import { TrackStatusFormField } from "@/modules/property-tracks/dtos/property-stage";
import { useDropdownOptions } from "@/modules/property-tracks/hooks/use-drop-down-options.hook";
import { StatusFieldsDropDowns } from "@/modules/property-tracks/constants";

const DropDownFieldsRenderer = ({
  field,
  section,
  control,
}: {
  field: TrackStatusFormField;
  section: FormSection;
  control: Control<any>;
}) => {
  const dropDownConfig =
    StatusFieldsDropDowns[field.name as keyof typeof StatusFieldsDropDowns];

  const { options, isLoading, handleSearchChange } = useDropdownOptions({
    queryKey: (dropDownConfig as FetchDropDownConfig).queryKey || field.name,
    fetchFn: (dropDownConfig as FetchDropDownConfig).fetchFn,
    transformData: (dropDownConfig as FetchDropDownConfig).transformData,
    staticOptions: (dropDownConfig as StaticDropDownConfig).staticOptions,
    searchable: (dropDownConfig as FetchDropDownConfig).searchable,
  });

  return (
    <Controller
      name={`${section.fieldLevel}.${field.name}`}
      control={control}
      render={({ field, fieldState }) => (
        <CustomAutoComplete
          options={options}
          multiple={false}
          fullWidth
          loading={isLoading}
          placeholder={dropDownConfig.placeholder}
          onChange={(value) => field.onChange(value)}
          handleSearch={handleSearchChange}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          value={field.value}
        />
      )}
    />
  );
};

export default DropDownFieldsRenderer;
